import { BaseContactDto } from '../../../shared/modules/base/dtos/base-contact.dto';

/**
 * Contact shown for a reservation booker. A pending matched guest uses the
 * customer contact. Every other case uses the booker party copy.
 */
export class RentalReservationBookerContactDto extends BaseContactDto {}
